module.exports = __webpack_public_path__ + "img/ic_user_host.ad79c819.svg";